
  import { defineComponent } from 'vue';
  import GrouperTitle from 'components/grouper-common/GrouperTitle.vue';
  import GrouperFooter from 'components/grouper-common/GrouperFooter.vue';
  import GrouperBody from 'components/grouper-common/GrouperBody.vue';
  import {useLayoutStore} from "stores/layout-store";
  import {GrouperLayoutMode} from "src/services/IodineGrouperService";


  export default defineComponent({
    name: 'MainLayout',
    components: {
      GrouperTitle,
      GrouperFooter,
      GrouperBody
    },
  });
